import * as React from 'react'
import { useEffect, useState } from 'react'
import Table from '@material-ui/core/Table'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import TableHead from '@material-ui/core/TableHead'
import TableBody from '@material-ui/core/TableBody'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { makeStyles } from '@material-ui/core/styles'
import GridItem from '../grid/GridItem'
import GridContainer from '../grid/GridContainer'
import Card from '../card/Card'
import CardHeader from '../card/CardHeader'
import CardBody from '../card/CardBody'

import styles from 'assets/jss/dorm-app/customSelectStyle.js'
import { getApiUrl } from '../../api/api'

const useStyles = makeStyles(styles)

export default function CurrentHSV() {
  const [proceeding, setProceeding] = useState(true)
  const [engagements, setEngagements] = useState(null)

  const classes = useStyles()

  useEffect(() => {
    setProceeding(true)
    getApiUrl({ semester: 'WS23/24' })
      .get(`/api/engagements`)
      .then(function(response) {
        setProceeding(false)
        setEngagements(response.data)
      })
      .catch(function(error) {
        setProceeding(false)
        console.log(error)
      })
  }, [])

  if (proceeding) {
    return (
      <Backdrop open={proceeding}>
        <CircularProgress color="inherit"/>
      </Backdrop>
    )
  }

  return (
    <div className={classes.container}>
      <GridContainer>
        {engagements
          ? Object.entries(engagements).map(([key, value]) => (
            <React.Fragment key={key}>
              <GridItem xs={12} sm={12} md={12}>
                <Card>
                  <CardHeader color="primary">
                    <h4 className={classes.cardTitleWhite}>{key}</h4>
                  </CardHeader>
                  <CardBody>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={12}>
                        <EngagementTabContent engagementInfos={value}/>
                      </GridItem>
                    </GridContainer>
                  </CardBody>
                </Card>
              </GridItem>
              <br/>
              <br/>
            </React.Fragment>
          ))
          : []}
      </GridContainer>
    </div>
  )
}

function EngagementTabContent(props) {
  const classes = useStyles()

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell className={classes.customTableHeader}>Name</TableCell>
          <TableCell className={classes.customTableHeader}>Email</TableCell>
          <TableCell className={classes.customTableHeader}>Telefonnummer</TableCell>
          <TableCell className={classes.customTableHeader}>Zimmer</TableCell>
          <TableCell className={classes.customTableHeader}>Flur</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {props.engagementInfos.map((info) => (
          <TableRow key={info.tenantRoom}>
            <TableCell>{info.tenantName}</TableCell>
            <TableCell>
              <a href={`mailto:${info.tenantEmail}`}> {info.tenantEmail} </a>
            </TableCell>
            <TableCell>{info.tenantPhone}</TableCell>
            <TableCell>{info.tenantRoom}</TableCell>
            <TableCell>{info.tenantFloor}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
